import type {NorafUpdate} from 'services/agent/types';
import type {AgentItemLink} from '../types';

export const createAgentLink = (
  agent: NorafUpdate,
  preText: string,
): AgentItemLink => {
  return {
    link: `/agent/${agent.agentId}`,
    tooltip: `${preText}: ${agent.name}`,
  };
};
